import { render, staticRenderFns } from "./third-total-list.vue?vue&type=template&id=7424fe87&scoped=true&"
import script from "./third-total-list.vue?vue&type=script&lang=js&"
export * from "./third-total-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7424fe87",
  null
  
)

export default component.exports